import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import staffs from '@/modules/staffs/routes';
import user from '@/modules/user/routes';
import organizations from '@/modules/organizations/routes';
import clients from '@/modules/clients/routes';
import products from '@/modules/products/routes';
import leads from '@/modules/leads/routes';
import cart from '@/modules/cart/routes';
import orders from '@/modules/orders/routes';
import subpartners from '@/modules/subpartners/routes';
import companies_users from '@/modules/companies-users/routes';
import repairs from '@/modules/repairs/routes';
import dispatches from '@/modules/dispatches/routes';
import { all_roles, check_user_internal } from '@/utils';
import notifications from '@/modules/notifications/routes';
import widgets from '@/modules/widgets/routes';
import marketing_fund from '@/modules/marketing-fund/routes';
import reports_roles from '@/modules/reports/routes';
import videos from '@/modules/videos/routes';
import brand_portal from '@/modules/brand-portal/routes';
import projects from '@/modules/projects/routes';
import courses_requests from '@/modules/courses-requests/routes';
import news from '@/modules/news/routes';
import patchnotes from '@/modules/patchnotes/routes';
import marketing_materials from '@/modules/marketing_materials/routes';
import analytics from '@/modules/analytics/routes';
import global_search from '@/modules/global-search/routes';
import conferences from '@/modules/conferences/routes';
import software_licenses from '@/modules/software-licenses/routes';
import polls from '@/modules/polls/routes';
import contacts from '@/modules/contacts/routes';
import retro_bonuses from '@/modules/retro-bonuses/routes';
import commercial_offers from '@/modules/commercial-offers/routes';
import calendar from '@/modules/events-calendar/routes';
import purchase_orders from '@/modules/purchase-orders/routes';
import data_pilot from '@/modules/data-pilot/routes';
import loans from '@/modules/loans/routes';
import alfa_api_loan_applications from '@/modules/alfa-api-loan-applications/routes';

Vue.use(VueRouter);

// по типу пользователя
// #TODO
// PROD VERSION
const internal_user_param = window.env.VUE_APP_KEYCLOAK_USER_TYPE_PARAM;

// DEV VERSION
// const internal_user_param = 'admin';

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    component: check_user_internal(internal_user_param)
      ? () => import(/* webpackChunkName: "home-internal" */ '@/modules/companies-users/views/CompaniesUsersManagers.vue')
      : () => import(/* webpackChunkName: "home-external" */ '@/modules/main-page/views/Main.vue'),
    meta: {
      access_roles: all_roles,
    },
  },
  ...staffs,
  ...user,
  ...organizations,
  ...clients,
  ...products,
  ...leads,
  ...cart,
  ...subpartners,
  ...orders,
  ...companies_users,
  ...repairs,
  ...dispatches,
  ...notifications,
  ...widgets,
  ...marketing_fund,
  ...reports_roles,
  ...videos,
  ...brand_portal,
  ...projects,
  ...courses_requests,
  ...news,
  ...patchnotes,
  ...marketing_materials,
  ...analytics,
  ...software_licenses,
  ...global_search,
  ...conferences,
  ...polls,
  ...contacts,
  ...retro_bonuses,
  ...commercial_offers,
  ...calendar,
  ...purchase_orders,
  ...data_pilot,
  ...loans,
  ...alfa_api_loan_applications,
];

export default routes;
